import Button from '../../elements/Button/Button';
import strings from '../../lang/lang';
import { checkPath } from '../../utils/helpers';
import { DesktopAndTablet } from '../../utils/responsiveQueries';
import {keycloak} from "../../keycloak-config";
import header from './Header.module.scss';
import { NavigationMenu } from '..';

const UnauthorizedLinks = ({ location, wrapperRef }) => {
  const isDocsPath = checkPath(location.pathname, 'docs');

  return (
    <DesktopAndTablet>
      <nav ref={wrapperRef} className={header.header__nav}>
        {!isDocsPath && (
          <NavigationMenu
            className="header"
          />
        )}
      </nav>

      <ul className={header.header__right}>
        <li>
          <Button name={strings.header.buttons.signUp} onClick={() => keycloak.register()} variant="gradient_auth_none" />
        </li>
        <li>
          <Button name={strings.header.buttons.signIn} onClick={() => keycloak.login()} variant="gradient_auth" />
        </li>
      </ul>
    </DesktopAndTablet>
  );
};

export default UnauthorizedLinks;
